import React from "react";
import { motion } from "framer-motion";
import { HeartHandshake, MessageSquare, BadgeCheck, Timer } from "lucide-react";
import { useI18n } from "@/i18n";

const ICONS = [HeartHandshake, MessageSquare, BadgeCheck, Timer];

export const About = () => {
  const { t } = useI18n();
  return (
    <section id="about" className="py-24 bg-navy text-white relative overflow-hidden" data-testid="about-section">
      <div className="absolute inset-0 tech-grid-dark opacity-60" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand/10 blur-3xl rounded-full" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand mb-3">{t.about.eyebrow}</p>
          <h2 className="font-head text-3xl sm:text-4xl font-semibold tracking-tight">{t.about.title}</h2>
          <p className="mt-5 text-white/70 leading-relaxed">{t.about.p1}</p>
          <p className="mt-4 text-white/70 leading-relaxed">{t.about.p2}</p>
          <p className="mt-4 text-white/70 leading-relaxed">{t.about.p3}</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {t.about.features.map((f, i) => {
            const Icon = ICONS[i] || HeartHandshake;
            return (
              <motion.div
                key={i}
                data-testid={`about-feature-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="bg-white/5 border border-white/10 rounded-md p-6 hover:border-brand/40 transition-colors"
              >
                <Icon className="w-8 h-8 text-brand" />
                <p className="font-head text-lg font-semibold mt-4 leading-tight">{f.title}</p>
                <p className="text-sm text-white/60 mt-1.5">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
